import { useTranslation } from "react-i18next";

import ch from '../../img/AboutUs/ch.png';

function GainComplete() {

  const { t } = useTranslation();

  return (
    <div className="relative pt-[80px] xl:pt-[160px] overflow-hidden">
      <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
        <div className="flex flex-col xl:flex-row justify-between items-center">
            <div>
                <p className="text-[24px] xl:text-[36px] zen-dots leading-[1.2] text-[#1E1C21] xl:max-w-[600px]">{t('aboutus.17')}</p>
                <p className="text-[12px] xl:text-[14px] text-[#000000B2] ibm-plex xl:max-w-[497px] mt-[20px] xl:mt-[40px]">{t('aboutus.18')}</p>
                <div className="flex gap-[10px] xl:gap-[30px] mt-[20px] xl:mt-[40px]">
                    <div className="bg-[#1E1C21] w-[4px] h-[4px] flex-shrink-0 mt-[7px]"></div>
                    <div>
                        <p className="text-[14px] xl:text-[16px] text-[#1F1F1F] font-[500] leading-[1.2] ibm-plex">{t('aboutus.19')}</p>
                         <p className="text-[12px] xl:text-[14px] text-[#000000B2] ibm-plex xl:max-w-[463px] mt-[12px]">{t('aboutus.20')}</p>
                    </div>
                </div>
                <div className="flex gap-[10px] xl:gap-[30px] mt-[20px] xl:mt-[25px]">
                    <div className="bg-[#1E1C21] w-[4px] h-[4px] flex-shrink-0 mt-[7px]"></div>
                    <div>
                        <p className="text-[14px] xl:text-[16px] text-[#1F1F1F] font-[500] leading-[1.2] ibm-plex">{t('aboutus.21')}</p>
                         <p className="text-[12px] xl:text-[14px] text-[#000000B2] ibm-plex xl:max-w-[463px] mt-[12px]">{t('aboutus.22')}</p>
                    </div>
                </div>
            </div>
            <img src={ch} alt="" className="mt-[25px] xl:mt-0"/>
        </div>
      </div>
    </div>
  );
}

export default GainComplete;
